import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import GeneralSettings from "./GeneralSettings";
import BenchMarkSettings from "./BenchMarkSettings";
import PromotionalBanner from "./PromotionalBanner";
import { useHistory, useLocation } from "react-router-dom";
const { TabPane } = Tabs;

const TabsList = [{
  title: "General Settings",
  Component: GeneralSettings,
},
{
  title: "Benchmark settings",
  Component: BenchMarkSettings,
} ,
{
  title: "Advertising Promotional Banner",
  Component: PromotionalBanner,
},
// {
//   title:"Bank account",
//   Component:BankAccountSettings
// }
]

const BusinessTabSettings = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const tabFromUrl = queryParams.get("tab");
  const validTabKey =
    tabFromUrl && /^\d+$/.test(tabFromUrl) && Number(tabFromUrl) >= 1 && Number(tabFromUrl) <= TabsList.length
      ? tabFromUrl
      : "1";
  const [activeKey, setActiveKey] = useState(validTabKey);

  useEffect(() => {
    const next = new URLSearchParams(location.search).get("tab");
    const key =
      next && /^\d+$/.test(next) && Number(next) >= 1 && Number(next) <= TabsList.length
        ? next
        : "1";
    setActiveKey(key);
  }, [location.search]);

  const onTabChange = (key) => {
    setActiveKey(key);
    history.replace({ pathname: location.pathname, search: `?tab=${key}` });
  };

  return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      {
        TabsList?.map(({ title, Component }, index) =>
          <TabPane
            tabBarStyle={{ color: "pink" }}
            tab={t(title)}
            key={`${index+1}`}
          >
            <Component />
          </TabPane>
        )
      }

    </Tabs>
  );
};

export default BusinessTabSettings;
